import { render, staticRenderFns } from "./FlagshipGoalsStepMediumGoal.vue?vue&type=template&id=55e1185d&"
import script from "./FlagshipGoalsStepMediumGoal.vue?vue&type=script&lang=ts&"
export * from "./FlagshipGoalsStepMediumGoal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VImg,VRow})
